import CreateEventRegistration from "./CreateEventRegistration";
export default CreateEventRegistration;
